const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : `0${n}`
}

export const formatTime = (date) => {
  const _date = date ?? new Date()
  const year = _date.getFullYear()
  const month = _date.getMonth() + 1
  const day = _date.getDate()
  // const hour = _date.getHours()
  // const minute = _date.getMinutes()
  // const second = _date.getSeconds()

  return `${[year, month, day].map(formatNumber).join('-')}`
}
